import { render, staticRenderFns } from "./FormDesignRender.vue?vue&type=template&id=495b63a5&scoped=true&"
import script from "./FormDesignRender.vue?vue&type=script&lang=js&"
export * from "./FormDesignRender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495b63a5",
  null
  
)

export default component.exports